{
  "panel": {
    "title": "Plan",
    "trackerTitle": "Plan Tracker",
    "loading": "Loading plan...",
    "empty": "No plan yet.",
    "emptyTitle": "No plan yet",
    "emptyHint": "Upload a task description to generate a plan.",
    "loadFailed": "Could not load plan."
  },
  "generation": {
    "starting": "Starting plan generation...",
    "structure": "Building plan structure...",
    "enrichment": "Enriching plan items...",
    "stage": "Stage {{stage}} of {{total}}",
    "itemsEnriched": "{{enriched}} of {{total}} items enriched",
    "complete": "Plan generated.",
    "failed": "Plan generation failed.",
    "errorContact": "Plan generation failed. Please retry.",
    "regenerate": "Regenerate plan",
    "regenerating": "Regenerating plan...",
    "abort": "Abort",
    "aborting": "Aborting..."
  },
  "review": {
    "title": "Review plan",
    "subtitle": "Approve, edit, or request changes to the plan before generating the report.",
    "approve": "Approve plan",
    "approveAndGenerate": "Approve and generate report",
    "approving": "Approving...",
    "approveFailed": "Could not approve plan.",
    "requestChanges": "Request changes",
    "feedbackTitle": "Plan feedback",
    "feedbackPlaceholder": "Describe what should change about the plan.",
    "feedbackSubmit": "Send feedback",
    "feedbackSubmitting": "Sending...",
    "feedbackEmpty": "Please describe your changes first.",
    "feedbackSent": "Feedback received. Updating plan...",
    "approveItem": "Approve item",
    "rejectItem": "Reject item",
    "approveAllItems": "Approve all",
    "rejectAllItems": "Reject all",
    "addItem": "Add item",
    "deleteItem": "Delete item",
    "moveUp": "Move up",
    "moveDown": "Move down",
    "indent": "Indent",
    "outdent": "Outdent"
  },
  "item": {
    "untitled": "Untitled section",
    "noDescription": "No description.",
    "edit": "Edit",
    "save": "Save",
    "cancel": "Cancel",
    "saving": "Saving...",
    "saveFailed": "Could not save changes.",
    "titleLabel": "Title",
    "descriptionLabel": "Description",
    "methodologyLabel": "Methodology",
    "dataRequirementsLabel": "Data requirements",
    "outputFormatLabel": "Output format",
    "qualityCriteriaLabel": "Quality criteria",
    "expand": "Expand",
    "collapse": "Collapse",
    "viewDetails": "View details",
    "rejected": "Rejected",
    "approved": "Approved",
    "pending": "Pending review"
  },
  "actions": {
    "approveAndStartReport": "Approve plan and start report",
    "abortAndRevise": "Abort and revise",
    "duplicate": "Duplicate"
  },
  "progress": {
    "buildingYourPlan": "Building Your Plan",
    "inProgress": "Plan generation in progress...",
    "stepPlanning": "Generating plan structure",
    "stepEnriching": "Enriching section details",
    "generatingStructure": "Generating plan structure...",
    "analyzing": "Analyzing...",
    "finalizing": "Finalizing plan structure...",
    "enrichingDetails": "Enriching section details...",
    "noPlan": "No plan available",
    "feedbackApplied": "Plan updated with your feedback",
    "feedbackRefreshFailed": "Plan refresh failed after feedback",
    "feedbackUpdateFailed": "Failed to update plan"
  }
}
